import { IoIosCheckmark } from "react-icons/io";

const Checkbox = ({ onChange, id, checked }) => {
  return (
    <label
      htmlFor={id}
      className={`border-2 mx-auto  rounded-md size-5 flex items-center justify-center cursor-pointer ${
        checked ? "bg-primary border-primary" : "bg-transparent border-white"
      }`}
    >
      {checked && <IoIosCheckmark className="text-black" size={20} />}
      <input
        onChange={onChange}
        type="checkbox"
        id={id}
        checked={checked}
        className="absolute opacity-0 cursor-pointer"
      />
    </label>
  );
};

export default Checkbox;
